<template>
  <v-card outlined class="py-2 px-3 align-center " :class="{ 'red lighten-4': hasError }" id="settings" v-bind="$attrs"
    v-on="{ ...$on, ...$listeners }">
    <v-row dense class="no-gutters flex-nowrap align-center" justify="start" style="width: 100%">
      <v-col class="shrink">
        <user-avatar :user="patrol" small size="32" :badgeVisible="patrol.tasks.length > 0" :badgeColor="badgeColor"
          :badgeValue="patrol.tasks.length"></user-avatar>
      </v-col>
      <v-col cols="auto" class="shrink mx-2">
        <div v-if="progress">
          <v-progress-linear :value="stats ? progress : 0" height="8" color="primary" rounded
             class="align-center"/>
          <div class="text-caption mt-1" style="min-width: 80px; max-width: 220px;">
            {{ progress }}
          </div>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="shrink mx-2">
        <div>
          <router-link v-if="task != null" class="text-decoration-none"
            :to="{ name: 'Event', params: { id: task.event.id } }">
            <task-status-icon v-if="task != null" :status="status" :stats="stats" class="mr-2"></task-status-icon>
          </router-link>
          <task-status-icon v-if="task == null" :status="free" :stats="stats" class="mr-2"></task-status-icon>
        </div>
      </v-col>
    </v-row>
    <v-row dense class="no-gutters flex-nowrap align-center" justify="start" v-if="task != null" style="width: 100%">
      <v-col class="shrink1">
        <span class="text-caption font-weight-bold">
          {{ site | codeName }}
        </span>
        <span class="text-caption font-weight-medium">
          {{ site.name }}
        </span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { patrolCardMixin } from '@/composables/usePatrolCard'

export default {
  name: 'PatrolCardHorizontal',
  inheritAttrs: false,
  mixins: [patrolCardMixin],
  props: {
    patrol: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showMenu() {
      this.$emit('click', this.patrol)
    },
  },
}
</script>

<style lang="sass">
</style>
